import { useMemo } from "react"
import { AutoComplete, DatePickerInput } from "../Components/Atoms"


export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {

  const options = useMemo(() => {
    if (preFilteredRows.length) {
      const optionsSet = new Set();
      preFilteredRows.forEach(row => {
        optionsSet.add(row.values[id])
      })
      const optionsArr = [...optionsSet.values()];
      const options = [{ label: 'All', value: 'all' }];
      optionsArr.forEach((val) => options.push({ label: `${val}`, value: val }))
      return options;
    }
  }, [id, preFilteredRows])

  return (
    <AutoComplete
      inputCover={"table-filter"}
      className={"table-filter-autocomplete-field"}
      options={options || []}
      placeholder={"Select"}
      value={filterValue ? filterValue : 'all'}
      onChange={value => setFilter(value !== 'all'  ? value : undefined)}
      isSearchable={false}
      inputName={id}
    />
  )
}

export function CalendarColumnFilter({
  column: { filterValue, setFilter, id },
}) {

  return (
    <DatePickerInput
      value={filterValue}
      onChange={value => {
        setFilter(value);
      }}
      inputName={id}
      inputCover={"table-filter"}
      className={"table-filter-datepicker-field"}
    />
  )
}

export const NoColumnFilter = () => <div />;

export const getFilters = (header) => {
  let obj = {}
  if (header?.filterTyp === "select") {
    obj['filter'] = 'select';
    obj['Filter'] = SelectColumnFilter;
  }
  else if (header?.filterTyp === "calender") {
    obj['filter'] = 'calendar';
    obj['Filter'] = CalendarColumnFilter;
  }
  else if (header?.filterTyp === "none") {
    obj['filter'] = 'none';
    obj['Filter'] = NoColumnFilter;
  }
  return obj;
}